import { render, staticRenderFns } from "./MiniList.vue?vue&type=template&id=58f3b2b6&"
import script from "./MiniList.vue?vue&type=script&lang=js&"
export * from "./MiniList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports